import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { CompleteActionItemBanner } from 'Components/ComponentLibrary/Organisms/CompleteActionItemBanner';
import PageHeader from 'Components/ComponentLibrary/Molecules/PageHeader';
import { FDContentContainer } from '@facet-wealth/design';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { HouseholdProfileBreadcrumbs } from 'Components/ComponentLibrary/Organisms/HouseholdProfileBreadcrumbs';
import { useModalContextSubmissionSuccessful } from 'Hooks/useRefreshEvent';
import {
  useProfilePageSubmissionContext,
  withProfilePageSubmissionContextProvider,
} from 'Views/Page/Content/Templates/ProfilePage/ProfilePageSubmissionContext';
import { dataAttrs } from 'Helpers/Testing';
import { ManageHouseholdMembers } from './ManageHouseholdMembers';

export const ProfilePage = withProfilePageSubmissionContextProvider(({ resource }) => {
  const { loadPageContentLink, refreshPageContentCollection } = usePageContentContext();
  const { clearModalCollection } = useModalContext();
  useBoneBackgroundColor();

  useModalContextSubmissionSuccessful((evt, clearModalCollectionDependency) => {
    switch (evt.detail.response.meta().type()) {
      case 'HouseholdAddress':
      case 'HouseholdPerson':
        refreshPageContentCollection();
        clearModalCollectionDependency();

      /* no default */
    }
  }, [clearModalCollection]);

  const { profilePageSubmit } = useProfilePageSubmissionContext();

  return (
    <>
      <CompleteActionItemBanner resource={resource} beforeCompletion={profilePageSubmit} />
      <FDContentContainer maxWidth={'xl'} {...dataAttrs('profile-page', resource)}>
        <PageHeader
          breadcrumbs={<HouseholdProfileBreadcrumbs resource={resource} onClickBreadcrumb={(link) => loadPageContentLink(link)} />}
          title={resource.attr('title')}
          subtitle={resource.attr('subtitle')}
        />
        <ManageHouseholdMembers
          addMemberRelationship={resource.withRelationship(fr.relationships.addHouseholdMember.name, (rel) => rel, () => null)}
          membersCollection={resource.attr('members')}
          refreshMembers={refreshPageContentCollection}
          address={resource.attr('address')}
          addressRelationship={resource.withRelationship(fr.relationships.address.name, (rel) => rel, () => null)}
        />
      </FDContentContainer>
    </>
  );
});

ProfilePage.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
